import jinjaToJS from "jinja-to-js";export default function templateModulesScrollToTopBtn(ctx) {
    var __result = "";
    var __tmp;
    var __runtime = jinjaToJS.runtime;
    var __filters = jinjaToJS.filters;
    var __globals = jinjaToJS.globals;
    var context = jinjaToJS.createContext(ctx);
    __result += "<button is=\"scroll-to-top-button\" class=\"scroll-to-top-button hidden-tablet\">\n    ";__result += "" + ((__tmp = (__filters.svg_icon("chevron"))) == null ? "" : __tmp);__result += "\n    <p class=\"scroll-to-top-button__text\">";__result += "" + ((__tmp = (context._("feeds.scroll_to_top_btn_text"))) == null ? "" : __tmp);__result += "</p>\n</button>";
    return __result;
}